<template>
  <v-container fluid>
    <v-card class="card-rounded">
      <v-form lazy-validation>
        <v-card-title>
          <span class="headline">Caixa</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="5">
                <v-row>
                  <v-col cols="4">
                    <v-select
                      :items="tipos"
                      label="Tipo"
                      item-text="label"
                      item-value="value"
                      required
                      v-model="tipo"
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="dataInicial"
                      v-mask="'##/##/####'"
                      label="Data inicial"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="dataFinal"
                      v-mask="'##/##/####'"
                      label="Data final"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="7">
                <v-row>
                  <v-col cols="6">
                    <v-text-field v-model="nome" label="Cliente"></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-btn color="primary" dark @click="getDadosCaixa()"
                      >Filtrar</v-btn
                    >
                  </v-col>
                  <v-col cols="4">
                    <v-btn color="primary" dark @click="getRelatorioCaixa()"
                      >Relatório</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-spacer></v-spacer
                ><span
                  >Saldo: {{ formatValue(saldo, saldo >= 0 ? "E" : "S") }}</span
                >
              </v-col>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="caixa"
                  :items-per-page="10"
                  :loading="loading"
                  :no-data-text="
                    loading ? 'Carregando' : 'Nenhum Registro para mostrar'
                  "
                  class="elevation-1"
                >
                  <template v-slot:[`item.data`]="{ item }">
                    <span>{{ formatDate(item.data) }}</span>
                  </template>
                  <template v-slot:[`item.tipo`]="{ item }">
                    <span>{{ item.tipo == "E" ? "Entrada" : "Saída" }}</span>
                  </template>
                  <template v-slot:[`item.valor`]="{ item }">
                    <span v-if="item.tipo == 'S'" style="color:#bd0909">{{
                      formatValue(item.valor, item.tipo)
                    }}</span>
                    <span v-else-if="item.tipo == 'E'" style="color:#4bcf13">{{
                      formatValue(item.valor, item.tipo)
                    }}</span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import Util from "../../service/util-service";
export default {
  data() {
    return {
      tipo: "",
      dataInicial: "",
      dataFinal: "",
      nome: "",
      saldo: 0,
      tipos: [
        { value: "", label: "Todos" },
        { value: "E", label: "Entrada" },
        { value: "S", label: "Saída" },
      ],
      headers: [
        {
          text: "Cliente",
          align: "left",
          sortable: true,
          value: "nome",
        },
        {
          text: "Descrição",
          align: "left",
          sortable: true,
          value: "descricao",
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "tipo",
        },
        {
          text: "Data",
          align: "left",
          sortable: true,
          value: "data",
        },
        {
          text: "Valor",
          align: "left",
          sortable: true,
          value: "valor",
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      caixa: "caixa",
    }),
  },
  created() {
    this.dataInicial = Util.dateFormat(new Date());
    this.dataFinal = Util.dateFormat(new Date());
    this.getDadosCaixa();
  },

  methods: {
    getRelatorioCaixa() {
      this.$store
        .dispatch("getRelatorioCaixa", {
          tipo: this.tipo,
          nome: this.nome,
          dataInicial: this.dataInicial,
          dataFinal: this.dataFinal,
        })
        .then((value) => {
          var byteCharacters = atob(value);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: "application/pdf;base64" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text:
              "Ouve um erro ao processar sua solicitação! Tente novamente mais tarde.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDadosCaixa() {
      this.loading = true;

      this.$store
        .dispatch("getDadosCaixa", {
          tipo: this.tipo,
          nome: this.nome,
          dataInicial: this.dataInicial,
          dataFinal: this.dataFinal,
        })
        .then((value) => {
          this.calcularSaldo();
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os registros de caixa",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    calcularSaldo() {
      let s = 0;
      for (var i = 0; i < this.caixa.length; i++) {
        let v = this.caixa[i].valor;
        if (this.caixa[i].tipo == "S") {
          v = v * -1;
        }
        s = s + v;
      }
      this.saldo = s;
      console.log(s);
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    formatValue(value, tipo) {
      return (
        (tipo == "E" ? "+ " : "- ") +
        value.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })
      );
    },
  },
};
</script>
